"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var StateMachine_1 = require("../../Abr/StateMachine");
var createStatePanicMode_1 = require("./State/createStatePanicMode");
var createStateRebuffer_1 = require("./State/createStateRebuffer");
var createStateSteady_1 = require("./State/createStateSteady");
function createStateMachine() {
    var stateMachine = new StateMachine_1.default();
    stateMachine.addState(createStatePanicMode_1.default());
    stateMachine.addState(createStateRebuffer_1.default());
    stateMachine.addState(createStateSteady_1.default());
    return stateMachine;
}
exports.default = createStateMachine;
//# sourceMappingURL=createStateMachine.js.map